export default __webpack_public_path__ + "static/media/hearing-icon.60c2fb3a.svg";